// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UploadOutlinedSvg from "@ant-design/icons-svg/es/asn/UploadOutlined";
import AntdIcon from '../components/AntdIcon';

var UploadOutlined = function UploadOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UploadOutlinedSvg
  }));
};

UploadOutlined.displayName = 'UploadOutlined';
export default React.forwardRef(UploadOutlined);